export default "__VITE_ASSET__BgUYOYnQ__"